/**
 * Component Entry
 *
 */

import Card from './Card'
export default Card
export * from './Card'
